import React from "react";
import {
  StyledRightPage,
  StyledSubscribeBox,
  StyledSubscribeButton,
  StyledSwitches,
} from "./styles";
import { Box, CircularProgress, Typography } from "@mui/material";
import { SubscribeModalSVGSmallInverted } from "src/icons/SubscribeModalSVG";
import { SuccessMobileHeader } from "./SuccessMobileHeader";
import { options } from "./utils";
import { useAppDispatch } from "src/store/store";
import {
  resetSubscribeGroups,
  setSubscribeGroups,
  useGetSubscribedGroups,
  useSubscribeState,
} from "src/store/features/subscribe.slice";
import api from "src/store/features/api";
import { trackEvent } from "src/Amplitude";

/**
 * This is the main componen in which user can toggle email preferences and hit subscribe button.
 * The right side of the subscribe page.
 * @returns The SubscribeRightComponent component.
 */
export default function SubscribeRightComponent({
  setStage,
}: {
  setStage: (stage: "initial" | "success") => void;
}) {
  const dispatch = useAppDispatch();
  const { subscribeEmail, signupSources } = useSubscribeState();
  const listNames = useGetSubscribedGroups();
  const [addCustomerToMarketingList, { isLoading }] = api.useAddContactToMarketingListMutation();

  // On finish load set initial state
  React.useEffect(() => {
    dispatch(resetSubscribeGroups());
  }, []);

  return (
    <StyledRightPage
      id="right-component"
      item
      xs={12}
      md={6}
      justifyContent={{ sm: "start", md: "center" }}>
      <SuccessMobileHeader />
      <Typography
        component="p"
        sx={{ color: "white", textAlign: "center", m: 4, fontSize: "16px" }}>
        Would you like to hear more from us?
      </Typography>
      <Box sx={{ padding: { xs: "40px 0px", md: "40px" } }}>
        <SubscribeModalSVGSmallInverted />
      </Box>
      <StyledSubscribeBox>
        <Typography variant="body1" sx={{ color: "white", mb: 2 }}>
          Subscribe to our newsletter to receive news exclusive from Caleb & Brown.
        </Typography>
        {options.map((el, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Typography variant="body2" sx={{ color: "white" }}>
              {el.label}
            </Typography>
            <StyledSwitches
              defaultChecked
              onChange={() => dispatch(setSubscribeGroups(el.group))}
            />
          </Box>
        ))}
      </StyledSubscribeBox>
      <div style={{ width: "100%", padding: "20px 25px 20px 20px" }}>
        <StyledSubscribeButton
          id="subscribe-button-after-signup"
          variant="contained"
          onClick={async () => {
            await addCustomerToMarketingList({
              sendgridContactToListDto: {
                email: subscribeEmail,
                listNames,
              },
            });
            setStage("success");
            trackEvent(
              "User subscribed to newsletter",
              { subscribeEmail, ...signupSources, ...listNames },
              "Subscribe",
            );
          }}>
          {isLoading ? (
            <CircularProgress size="24px" sx={{ color: "white" }} />
          ) : (
            "Confirm My Subscription"
          )}
        </StyledSubscribeButton>
      </div>
    </StyledRightPage>
  );
}
